import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Autocomplete, TextField } from '@mui/material';
import { Box } from '@mui/system';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SearchCartItemDialog = ({open, handleClose, handleSearchCartItem, items}) => {
  const [selectedItem, setSelectedItem] = React.useState();
  const [disabled, setDisabled] = React.useState(true);

  React.useEffect(() => {
    const validate = async() => {
      setDisabled(selectedItem === undefined || selectedItem === null)
    };
    validate();
  },[selectedItem]);
  const handleSave = async() => {
    handleSearchCartItem(selectedItem)
  };
  const handleCloseDialog = async() => {
    handleClose();
  };
  return (
    <div>
      <Dialog open={open} onClose={handleCloseDialog} TransitionComponent={Transition} sx={{width: "100vw", height: "100vh"}}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseDialog}><CloseIcon /></IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Search Item</Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
              disablePortal
              options={items}
              sx={{ width: 300 }}
              renderInput={
                (params) => <TextField sx={{ width: 430 }} {...params} label="Item Name" inputProps={{...params.inputProps}}
                variant="standard"
                size="small"/>
              }
              size="small"
              onHighlightChange= {(event, option, reason) => {
                setSelectedItem(option);
              }}
              getOptionLabel={(option) => option.itemName.toUpperCase() }
              renderOption={(props, option) => (
                <Box {...props} >
                  {option.itemKey} | {option.itemName.toUpperCase()} | {option.sellingPriceInclTax}
                </Box>                
              )}
            />
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={12} />
            <Grid item xs={12} />
            <Grid item xs={12}><Button autoFocus variant="contained" disabled={disabled} onClick={handleSave} fullWidth>Select</Button></Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default SearchCartItemDialog
